import { detectLocale, type SupportedLocale } from "../i18n";

// The old tinkr-locale key stored automatic guesses as well as user choices.
// It cannot establish an explicit preference, so re-detect once on migration.
export const LOCALE_PREFERENCE_KEY = "tinkr-locale-preference";

/** Shared by both entrypoints and rendered apps; never persists detection. */
export function initialLocale(): SupportedLocale {
  if (typeof window === "undefined") return "en";
  const language = new URLSearchParams(window.location.search).get("lang");
  let stored: string | null = null;
  try { stored = window.localStorage.getItem(LOCALE_PREFERENCE_KEY); } catch { /* Browser preferences still work. */ }
  const browser = window.navigator.languages?.length
    ? window.navigator.languages : [window.navigator.language];
  return detectLocale([language ?? "", stored ?? "", ...browser]);
}

/** Only call after a deliberate language selection, never during mounting. */
export function rememberLocaleChoice(locale: SupportedLocale): void {
  if (typeof window === "undefined") return;
  try { window.localStorage.setItem(LOCALE_PREFERENCE_KEY, locale); } catch { /* Keep the choice in the URL for this tab. */ }
  const params = new URLSearchParams(window.location.search);
  params.set("lang", locale);
  window.history.replaceState(window.history.state, "",
    `${window.location.pathname}?${params.toString()}${window.location.hash}`);
}
